import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  buildI18nResources,
  DEFAULT_LANGUAGE_CODE,
  languageCodeToDir,
  normalizeLanguageCode,
  type LanguageCode,
} from '@/i18n/resources';

let initialized = false;

export async function initI18n(languageCode?: string | null): Promise<LanguageCode> {
  const resolved = normalizeLanguageCode(languageCode);
  const resources = buildI18nResources();

  if (!initialized) {
    await i18n.use(initReactI18next).init({
      resources,
      lng: resolved,
      fallbackLng: DEFAULT_LANGUAGE_CODE,
      defaultNS: 'common',
      ns: [
        'common', 'auth', 'validation', 'errors', 'workflow', 'navigation', 'hr', 'notifications', 'toast', 'pos', 'work', 'org',
        'finance', 'crm', 'desk', 'procurement', 'identity', 'leadgen', 'marketing', 'onboarding', 'projects', 'social', 'warehouse', 'master', 'inventory',
      ],
      interpolation: { escapeValue: false },
      returnEmptyString: false,
    });
    initialized = true;
  } else {
    await i18n.changeLanguage(resolved);
  }

  applyDocumentLanguage(resolved);
  return resolved;
}

export function applyDocumentLanguage(languageCode: LanguageCode): void {
  const html = document.documentElement;
  html.lang = languageCode.replace('_', '-');
  html.dir = languageCodeToDir(languageCode);
}

export { i18n };
